<!-- 学校-引入课程 -->
<template>
  <div class="container">
    <div class="index" v-if="!detail.show">
      <div class="title">
        <div class="span1">
          <span>{{ $route.name }}</span>
        </div>
      </div>

      <div>
        <el-form :inline="true" :model="queryParams" label-width="70px">
          <el-form-item label="">
            <el-input
              v-model="queryParams.name"
              placeholder="请输入课程名称"
              clearable
              @clear="getDataList"
            ></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input
              v-model="queryParams.orgName"
              placeholder="请输入所属机构"
              clearable
              @clear="getDataList"
            ></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-select
              v-model="queryParams.importState"
              clearable
              @clear="getDataList"
              placeholder="引入状态"
              class="label"
            >
              <el-option
                v-for="item in importStateList"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select
              v-model="queryParams.state"
              clearable
              @clear="getDataList"
              placeholder="审核状态"
              class="label"
            >
              <el-option
                v-for="item in stateList"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="" style="margin-left: 20px">
            <el-button type="primary" size="small" @click="searchFun()"
              >搜索</el-button
            >
            <!-- <el-button style="margin-left:20px;" size="small" @click='importsFun()'>批量引入</el-button> -->
          </el-form-item>
        </el-form>

        <div class="table">
          <!-- @selection-change="handleSelectionChange" -->
          <el-table :data="tableData" style="width: 100%">
            <!-- <el-table-column type="selection" width="55" align="center" prop="show" :selectable='checkboxT' disabled='true'>
    				</el-table-column> -->
            <el-table-column prop="coverUrl" label="课程封面" align="center">
              <template slot-scope="scope">
                <img :src="scope.row.coverUrl" style="height: 42px" alt="" />
              </template>
            </el-table-column>
            <el-table-column
              prop="cname"
              label="课程名称"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="typeName"
              label="课程类型"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="scope"
              label="适用年级"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <p>{{ getGrade(scope.row.scope) }}</p>
              </template>
            </el-table-column>
            <el-table-column
              prop="source"
              label="所属机构"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <!-- <el-table-column prop="auditUnit" label="所属教育局" show-overflow-tooltip align="center">
                    </el-table-column> -->
            <el-table-column
              prop="coverArea"
              label="课程覆盖区域"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="auditState"
              label="审核状态"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <p>{{ stateObj[scope.row.auditState] }}</p>
              </template>
            </el-table-column>

            <!-- <el-table-column prop="introduceTime" label="引入时间" show-overflow-tooltip align="center">
						<template slot-scope="scope">
							<p>{{  dayjs(scope.row.introduceTime).format("YYYY-MM-DD") ||dayjs(scope.row.attemptBeginTime).format("YYYY-MM-DD")}}</p>
						</template>
                    </el-table-column> -->
            <el-table-column
              header-align="center"
              align="center"
              label="操作"
              fixed="right"
              width="200"
            >
              <template slot-scope="scope">
                <!-- <el-button v-if="scope.row.state==='0'" :disabled="scope.row.auditState==='0'" type="text" size="small" @click="applyFor(scope.row)">试课申请</el-button>
							<el-button v-if="scope.row.state==='1'" :disabled="scope.row.auditState==='0'" type="text" size="small" @click="cancelApply(scope.row)">取消试课</el-button> -->
                <el-button type="text" size="small" @click="toDetail(scope.row)"
                  >查看详情</el-button
                >
                <el-button
                  v-if="scope.row.introduceState === '0'"
                  :disabled="
                    scope.row.auditState !== '2' && scope.row.auditState !== '1'
                  "
                  type="text"
                  size="small"
                  @click="importFun(scope.row)"
                  >引入</el-button
                >
                <el-button
                  v-if="scope.row.introduceState === '1'"
                  :disabled="
                    scope.row.auditState !== '2' && scope.row.auditState !== '1'
                  "
                  type="text"
                  size="small"
                  @click="cancelImportFun(scope.row)"
                  >取消引入</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination">
            <el-pagination
              background
              :current-page="pageNum"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pageSize"
              :total="totalPage"
              layout="total,prev, pager, next,jumper,sizes"
              @size-change="sizeChangeHandle"
              @current-change="currentChangeHandle"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
    <Detail
      :info.sync="detail.info"
      v-show="detail.show"
      @to-index="toIndex"
      :type="'import'"
      :importAuditState="importAuditState"
      :importItem="importItem"
      @to-init="init"
    ></Detail>
    <el-dialog
      center
      :title="'请选择授课教师'"
      :width="'360px'"
      :close-on-click-modal="false"
      :visible.sync="visible"
    >
      <div class="confirm">
        <div class="content">
          <el-select
            v-model="teacher"
            clearable
            placeholder="请选择授课教师"
            filterable
          >
            <el-option
              v-for="item in teacherList"
              :key="item.user_id + 'teacherList'"
              :label="item.name"
              :value="item.user_id"
            ></el-option>
          </el-select>
        </div>
        <div class="dialog-footer">
          <el-button type="primary" size="small" @click="importConfirm()"
            >确定</el-button
          >
          <el-button
            size="small"
            style="margin-left: 20px"
            @click="visible = false"
            >取消</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import schoolApi from "@/api/schoolApi/index.js";
import { getDetail } from "@/api/mechanismApi/curriculum.js";
import util from "@/utils/util.js";
import dayjs from "dayjs";
import _ from "lodash";
import { schoolTeacherList } from "@/api/user/userCenter";
import educationApi from "@/api/education/index.js";
export default {
  components: {
    Detail: () => import("../allCourse/detail.vue"),
  },
  data() {
    return {
      pageNum: 1,
      pageSize: 10,
      totalPage: 0,
      queryParams: {
        name: "",
        orgName: "",
        state: "",
        importState: "",
      },
      lyList: [],
      stateList: [
        { id: "1", label: "待审核" },
        { id: "2", label: "审核通过" },
      ],
      stateObj: {
        0: "未送审",
        1: "待审核",
        2: "已审核通过",
        3: "审核失败",
      },
      importStateList: [
        { id: "0", label: "未引入" },
        { id: "1", label: "已引入" },
      ],
      tableData: [],
      detail: {
        info: {},
        show: false,
      },
      school_info: JSON.parse(sessionStorage.getItem("classList")),
      semesterArr: JSON.parse(sessionStorage.getItem("semesterList")),
      multipleSelection: [],
      visible: false,
      teacherList: [],
      teacher: "",
      importItem: {},
      importType: "single",
      importAuditState: "",
    };
  },
  watch: {},
  created() {
    this.getDataList();
  },
  methods: {
    dayjs,
    checkboxT(row, index) {
      if (row.auditState === "2" && row.introduceState !== "1") {
        return 1;
      } else {
        return 0;
      }
    },
    init() {
      this.queryParams = {
        cname: "",
        orgName: "",
        state: "",
        importState: "",
      };
      this.pageNum = 1;
      this.getDataList();
    },
    getGrade(scope) {
      if (!scope) return "";
      return util.getGrade(scope);
    },
    async getDataList() {
      let params = {
        cname: this.queryParams.name,
        orgName: this.queryParams.orgName,
        introduceState: this.queryParams.importState,
        auditState: this.queryParams.state,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      };
      let res = await schoolApi.getSchoolCourseImportList(params);
      if (res.result === "000000") {
        this.tableData = res.data?.list || [];
        this.totalPage = res.data?.total || 0;
      }
    },
    searchFun() {
      this.pageNum = 1;
      this.getDataList();
    },
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.getDataList();
    },
    currentChangeHandle(val) {
      this.pageNum = val;
      this.getDataList();
    },
    async toDetail(item) {
      let params = {
        id: item.cid,
      };
      let paramsData = {
        cid: item.cid,
        orgId: sessionStorage.getItem("orgId"),
      };
      let { result, data } = await getDetail(params);
      // let res= await educationApi.getEducationCourseauditrecord(paramsData);
      if (result == "000000") {
        data.orgName = item.source;
        this.detail.info = data;
        // if(res.result==='000000'){
        // 	console.log('审批信息',res)
        // 	if (res.data.length != 0) {
        // 		this.detail.info.operateList=res.data || [];
        // 	}else{
        // 		this.detail.info.operateList=[{
        // 			auditState: "",
        // 			operateOpinion: "无审核记录",
        // 			operateOrgName: "",
        // 		}]
        // 	}
        // }
        this.detail.show = true;
      } else {
        this.$message({
          type: "error",
          message: "获取信息失败",
        });
      }
    },
    toIndex(type) {
      this.detail.show = false;
      this.importAuditState = "";
      if (type === "importSuccess") {
        this.getDataList();
      }
    },
    // 试课申请
    applyFor(item) {
      let vm = this;
      util
        .handleCofirm("确定发起试课申请?", "info")
        .then(async (res) => {
          let params = {
            cid: item.cid,
            cname: item.cname,
            typeId: item.typeId,
            typeName: item.typeName || "",
          };
          let { result } = await schoolApi.schoolCourseApply(params);
          if (result == "000000") {
            vm.$message({
              type: "success",
              duration: 1500,
              message: "操作成功",
            });
            vm.getDataList();
          } else {
            vm.$message({
              type: "error",
              duration: 1500,
              message: "操作失败",
            });
          }
        })
        .catch((err) => {
          console.log("err", err); // cancel
        });
    },
    // 取消试课
    cancelApply(item) {
      let vm = this;
      util
        .handleCofirm("确定取消试课?", "info")
        .then(async (res) => {
          let params = {
            cid: item.cid,
          };
          let { result } = await schoolApi.schoolCourseCancel(params);
          if (result == "000000") {
            vm.$message({
              type: "success",
              duration: 1500,
              message: "操作成功",
            });
            vm.getDataList();
          } else {
            vm.$message({
              type: "error",
              duration: 1500,
              message: "操作失败",
            });
          }
        })
        .catch((err) => {
          console.log("err", err); // cancel
        });
    },
    // 取消引入
    cancelImportFun(item) {
      let vm = this;
      util
        .handleCofirm("确定取消引入?", "info")
        .then(async (res) => {
          let params = {
            cid: item.cid,
          };
          let { result } = await schoolApi.schoolCourseCancelcourse(params);
          if (result == "000000") {
            vm.$message({
              type: "success",
              duration: 1500,
              message: "操作成功",
            });
            vm.getDataList();
          } else {
            vm.$message({
              type: "error",
              duration: 1500,
              message: "操作失败",
            });
          }
        })
        .catch((err) => {
          console.log("err", err); // cancel
        });
    },
    // 批量引入
    importsFun() {
      if (!this.multipleSelection.length) {
        this.$message.error("请选择课程");
        return false;
      }
      this.importType = "more";
      this.visible = true;
    },
    // 引入
    async importFun(item) {
      this.importItem = item;
      if (item.auditState == "1") {
        // 待审核
        this.importAuditState = "1";
        this.toDetail(item);
      } else if (item.auditState == "2") {
        // 审核通过
        this.importAuditState = "2";
        this.importConfirm();
      }
      // 获取学校教师列表
      // let params={
      // 	top_org_id:item.orgId,
      // 	page:1,
      // 	page_size:500,
      // 	user_type: "1,5",
      // 	need_role: "1",
      // }
      // let teacherRes=await schoolTeacherList(params);
      // console.log('教师信息',teacherRes)
      // if(teacherRes.code==='000000'){
      // 	this.teacherList=teacherRes.result.member_list || [];
      // 	this.importType = 'single';
      // 	this.visible=true;
      // 	this.importItem=item;
      // }else{
      // 	this.$message.error('获取老师信息失败');
      // 	return false;
      // }
    },
    // 引入确认
    importConfirm: _.throttle(
      async function () {
        let vm = this;
        util.handleCofirm("确定引入课程?", "info").then(async (res) => {
          // if(!this.teacher){
          // 	this.$message.error('授课老师不能为空');
          // 	return false;
          // }
          // let teacher=this.teacherList.filter(e=>e.user_id===this.teacher)[0];
          let params = {
            cid: this.importItem.cid,
            orgName: vm.importItem.source,
            orgId: vm.importItem.orgId,
            // personId: teacher.user_id,
            // name: teacher.name,
          };
          let { result } = await schoolApi.schoolCourseImportcourse(params);
          if (result == "000000") {
            vm.$message({
              type: "success",
              duration: 1500,
              message: "操作成功",
            });
            vm.visible = false;
            vm.getDataList();
          } else {
            vm.$message({
              type: "error",
              duration: 1500,
              message: "操作失败",
            });
          }
        });
      },
      3000,
      { leading: true, trailing: false }
    ),
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.index {
  width: 100%;
  height: 100%;
  padding: 0 30px 30px;
  overflow: auto;
  .title {
    height: 60px;
    line-height: 48px;
    border-bottom: 1px solid #eaeaea;
    margin-bottom: 20px;
    display: flex;
    justify-content: flex-start;
    .span1 {
      font-family: "PingFang SC Bold";
      font-weight: bold;
      font-size: 20px;
      text-align: left;
      color: #000;
      margin-right: 30px;
    }
  }

  ::v-deep .el-form .el-input__inner {
    width: 180px;
    height: 32px;
    border-radius: 3px;
    background: #fff;
    border: 1px solid #ddd;
  }

  ::v-deep .el-table__header tr th {
    background: #f7f7f7;
    box-shadow: 0px 1px 0px #eaeaea;
  }

  ::v-deep .el-date-editor .el-range-separator {
    line-height: 22px;
  }

  .pagination {
    text-align: center;
    margin-top: 30px;
  }
}
.confirm {
  .content {
    display: flex;
    justify-content: center;
  }
  .dialog-footer {
    margin-top: 30px;
  }
}
</style>
